import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/Select';
import { useUpdateInstanceTypeStatus } from '../hooks/api';
import { toast } from 'sonner';
import { useDispatch } from 'react-redux';
import { fetchDetail } from '@/store/actions/typemark';
import { useTypemarkContext } from '../TypemarkContext';

const STATUS_OPTIONS = [
  { value: 'new', label: 'Nové' },
  { value: 'in_progress', label: 'Rozpracované' },
  { value: 'done', label: 'Hotové' },
  { value: 'checked', label: 'Zkontrolované' },
  { value: 'postponed', label: 'Odložené' },
  { value: 'needs_edit', label: 'K úpravě' },
];

type StatusDropdownProps = {
  selectedDetail: Record<string, any>;
};

const StatusDropdown = ({ selectedDetail }: StatusDropdownProps) => {
  const dispatch = useDispatch();
  const { selected } = useTypemarkContext() || {};
  const updateStatus = useUpdateInstanceTypeStatus();

  const selectedIds = Object.values(selected || {});
  const isMultiMode = selectedIds.length > 1;

  const currentStatus = !isMultiMode ? selectedDetail?.status : undefined;

  const handleStatusChange = (status: string) => {
    const ids = isMultiMode ? (selectedIds as string[]) : [selectedDetail?.id];

    updateStatus.mutate(
      { instanceTypeIds: ids, status },
      {
        onSuccess: () => {
          toast.success('Stav byl úspěšně změněn');
          if (!isMultiMode && selectedDetail?.id) {
            dispatch(fetchDetail(selectedDetail.id));
          }
        },
        onError: (err) => {
          console.error(err);
        },
      }
    );
  };

  return (
    <Select value={currentStatus} onValueChange={handleStatusChange}>
      <SelectTrigger size="sm" className="w-[160px]" data-testid="typemark-status-dropdown">
        <SelectValue placeholder="Změnit stav" />
      </SelectTrigger>
      <SelectContent>
        {STATUS_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default StatusDropdown;
